// extracted by mini-css-extract-plugin
export default {"productOrderContent":"OrderStepSelectProdType_productOrderContent__es98a","productList":"OrderStepSelectProdType_productList__CV+d5"};